import React, { useState } from 'react';
import { FaBan, FaBell, FaCheck, FaExclamationTriangle, FaInfo, FaTimes, FaEye, FaExternalLinkAlt, FaSpinner } from 'react-icons/fa';
import { limitaTexto } from '../util/util';

export default function ModalNotificacoes({ isOpen, onClose, notificacoes, onMarcarComoLida, carregando = false }) {
    const [processandoLinks, setProcessandoLinks] = useState({});

    const handleAbrirLink = (notificacao) => {
        if (notificacao.link) {
            try {
                // Marca como processando
                setProcessandoLinks(prev => ({ ...prev, [notificacao.id]: true }));

                // Marca como lida primeiro
                onMarcarComoLida(notificacao);

                // Pequeno delay para garantir que a notificação seja marcada
                setTimeout(() => {
                    // Verifica se é um link interno (começa com /) ou externo
                    if (notificacao.link.startsWith('/')) {
                        // Link interno - navega na mesma aba
                        window.location.href = notificacao.link;
                    } else if (notificacao.link.startsWith('http://') || notificacao.link.startsWith('https://')) {
                        // Link externo - abre em nova aba
                        window.open(notificacao.link, '_blank');
                    } else {
                        // Link relativo - adiciona o protocolo se necessário
                        const fullUrl = notificacao.link.startsWith('//') ? `https:${notificacao.link}` : notificacao.link;
                        window.open(fullUrl, '_blank');
                    }
                }, 300);
            } catch (error) {
                console.error('Erro ao abrir link:', error);
                // Fallback: tenta abrir como link interno
                window.location.href = notificacao.link;
            } finally {
                // Remove o estado de processamento
                setProcessandoLinks(prev => ({ ...prev, [notificacao.id]: false }));
            }
        }
    };
    if (!isOpen) return null;

    const getIcone = (tipo) => {
        switch (tipo) {
            case 'informacao':
                return <FaInfo size={16} className="text-info" />;
            case 'atencao':
                return <FaExclamationTriangle size={16} className="text-warning" />;
            case 'erro':
                return <FaBan size={16} className="text-danger" />;
            case 'sucesso':
                return <FaCheck size={16} className="text-success" />;
            default:
                return <FaBell size={16} className="text-secondary" />;
        }
    };

    const getCorStatus = (situacao) => {
        return situacao === 'nova' ? 'text-primary fw-bold' : 'text-muted';
    };

    const formatarData = (data) => {
        const dataObj = new Date(data);
        const dia = String(dataObj.getDate()).padStart(2, '0');
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
        const ano = dataObj.getFullYear();
        const hora = String(dataObj.getHours()).padStart(2, '0');
        const minuto = String(dataObj.getMinutes()).padStart(2, '0');
        return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    };

    const notificacoesNovas = notificacoes.filter(n => n.situacao === 'nova');
    const notificacoesLidas = notificacoes.filter(n => n.situacao === 'lido');

    return (
        <>
            <div className="modal-overlay" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1050,
                animation: 'fadeIn 0.3s ease-in-out'
            }}>
                <div className="modal-content" style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    width: '90%',
                    maxWidth: '800px',
                    maxHeight: '80vh',
                    overflow: 'hidden',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                    transition: 'all 0.3s ease'
                }}>
                    {/* Header */}
                    <div className="modal-header" style={{
                        padding: '20px',
                        borderBottom: '1px solid #dee2e6',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: '#f8f9fa'
                    }}>
                        <div>
                            <h5 className="mb-0">
                                <FaBell className="me-2" />
                                Notificações
                            </h5>
                            <small className="text-muted">
                                {carregando ? 'Carregando...' : `${notificacoesNovas.length} nova(s), ${notificacoesLidas.length} lida(s)`}
                            </small>
                        </div>
                        <button
                            onClick={onClose}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '20px',
                                cursor: 'pointer',
                                color: '#6c757d'
                            }}
                        >
                            <FaTimes />
                        </button>
                    </div>

                    {/* Body */}
                    <div className="modal-body" style={{
                        padding: '0',
                        maxHeight: '60vh',
                        overflowY: 'auto'
                    }}>
                        {carregando ? (
                            <div style={{
                                padding: '60px 40px',
                                textAlign: 'center',
                                color: '#6c757d',
                                backgroundColor: '#f8f9fa'
                            }}>
                                <div style={{
                                    fontSize: '48px',
                                    color: '#007bff',
                                    marginBottom: '20px',
                                    animation: 'spin 1s linear infinite'
                                }}>
                                    <FaSpinner />
                                </div>
                                <h5 style={{ color: '#6c757d', marginBottom: '10px' }}>
                                    Carregando notificações...
                                </h5>
                                <p style={{ color: '#adb5bd', fontSize: '14px' }}>
                                    Aguarde enquanto buscamos suas notificações.
                                </p>
                            </div>
                        ) : notificacoes.length === 0 ? (
                            <div style={{
                                padding: '60px 40px',
                                textAlign: 'center',
                                color: '#6c757d',
                                backgroundColor: '#f8f9fa'
                            }}>
                                <div style={{
                                    fontSize: '64px',
                                    color: '#dee2e6',
                                    marginBottom: '20px'
                                }}>
                                    🔔
                                </div>
                                <h5 style={{ color: '#6c757d', marginBottom: '10px' }}>
                                    Nenhuma notificação
                                </h5>
                                <p style={{ color: '#adb5bd', fontSize: '14px' }}>
                                    Você não tem notificações no momento.
                                </p>
                            </div>
                        ) : (
                            <div>
                                {/* Notificações Novas */}
                                {notificacoesNovas.length > 0 && (
                                    <div>
                                        <div style={{
                                            padding: '15px 20px',
                                            backgroundColor: '#e3f2fd',
                                            borderBottom: '1px solid #dee2e6',
                                            fontWeight: 'bold',
                                            color: '#1976d2'
                                        }}>
                                            Novas ({notificacoesNovas.length})
                                        </div>
                                        {notificacoesNovas.map((notificacao, index) => (
                                            <div
                                                key={notificacao.id}
                                                style={{
                                                    padding: '15px 20px',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    backgroundColor: '#fff',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    borderLeft: '4px solid #007bff'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = '#f8f9fa';
                                                    e.target.style.transform = 'translateX(5px)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = '#fff';
                                                    e.target.style.transform = 'translateX(0)';
                                                }}
                                                onClick={() => onMarcarComoLida(notificacao)}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                    <div style={{ marginTop: '2px' }}>
                                                        {getIcone(notificacao.tipo)}
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'flex-start',
                                                            marginBottom: '8px'
                                                        }}>
                                                            <div className={getCorStatus(notificacao.situacao)}>
                                                                {notificacao.texto}
                                                            </div>
                                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                                <small className="text-muted">
                                                                    {formatarData(notificacao.data)}
                                                                </small>
                                                                <FaEye size={12} className="text-muted" />
                                                            </div>
                                                        </div>
                                                        {notificacao.link && (
                                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '8px' }}>
                                                                <small className="text-primary" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                    <FaExternalLinkAlt size={10} />
                                                                    Clique para visualizar
                                                                </small>
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleAbrirLink(notificacao);
                                                                    }}
                                                                    title={notificacao.link}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        color: '#007bff',
                                                                        cursor: 'pointer',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        transition: 'all 0.2s ease'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.backgroundColor = '#e3f2fd';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.backgroundColor = 'transparent';
                                                                    }}
                                                                >
                                                                    <FaExternalLinkAlt size={10} />
                                                                    Abrir
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* Notificações Lidas */}
                                {notificacoesLidas.length > 0 && (
                                    <div>
                                        <div style={{
                                            padding: '15px 20px',
                                            backgroundColor: '#f8f9fa',
                                            borderBottom: '1px solid #dee2e6',
                                            fontWeight: 'bold',
                                            color: '#6c757d'
                                        }}>
                                            Lidas ({notificacoesLidas.length})
                                        </div>
                                        {notificacoesLidas.map((notificacao, index) => (
                                            <div
                                                key={notificacao.id}
                                                style={{
                                                    padding: '15px 20px',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    backgroundColor: '#fff',
                                                    borderLeft: '4px solid #6c757d',
                                                    opacity: 0.8
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                    <div style={{ marginTop: '2px' }}>
                                                        {getIcone(notificacao.tipo)}
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'flex-start',
                                                            marginBottom: '8px'
                                                        }}>
                                                            <div className={getCorStatus(notificacao.situacao)}>
                                                                {notificacao.texto}
                                                            </div>
                                                            <small className="text-muted">
                                                                {formatarData(notificacao.data)}
                                                            </small>
                                                        </div>
                                                        {notificacao.link && (
                                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '8px' }}>
                                                                <small className="text-muted" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                    <FaExternalLinkAlt size={10} />
                                                                    Já visualizada
                                                                </small>
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                        handleAbrirLink(notificacao);
                                                                    }}
                                                                    disabled={processandoLinks[notificacao.id]}
                                                                    title={notificacao.link}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        color: processandoLinks[notificacao.id] ? '#adb5bd' : '#6c757d',
                                                                        cursor: processandoLinks[notificacao.id] ? 'not-allowed' : 'pointer',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        transition: 'all 0.2s ease',
                                                                        opacity: processandoLinks[notificacao.id] ? 0.6 : 1
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!processandoLinks[notificacao.id]) {
                                                                            e.target.style.backgroundColor = '#f8f9fa';
                                                                        }
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        if (!processandoLinks[notificacao.id]) {
                                                                            e.target.style.backgroundColor = 'transparent';
                                                                        }
                                                                    }}
                                                                >
                                                                    {processandoLinks[notificacao.id] ? (
                                                                        <>
                                                                            <FaSpinner size={10} style={{ animation: 'spin 1s linear infinite' }} />
                                                                            Processando...
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <FaExternalLinkAlt size={10} />
                                                                            Abrir
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div className="modal-footer" style={{
                        padding: '15px 20px',
                        borderTop: '1px solid #dee2e6',
                        backgroundColor: '#f8f9fa',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <small className="text-muted">
                            {carregando ? 'Carregando...' : `Total: ${notificacoes.length} notificação(ões)`}
                        </small>
                        <button
                            onClick={onClose}
                            style={{
                                padding: '8px 16px',
                                border: '1px solid #dee2e6',
                                borderRadius: '4px',
                                backgroundColor: '#fff',
                                cursor: 'pointer'
                            }}
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `
            }} />
        </>
    );
} 